import * as React from 'react'
import * as ReactDOM from 'react-dom'

import { SearchBar } from "./SearchBar";
import { PolicyProvider } from '../Shared/Permissions/PolicyContext';

let mount = document.getElementById("searchbar-mount");

if (mount) {
    ReactDOM.render(
    <PolicyProvider>
        <SearchBar />
    </PolicyProvider>
    , mount);
}

